import { resolveBrowserTimezone, timezoneChangeNeedsConfirmation, } from "../../utils/timezone";
export const NO_PLAN_QUOTES = {
    singleVisit: null,
    packs: {},
    queueCurrency: null,
};
function sameQuote(a, b) {
    if (a === null || b === null)
        return a === b;
    return a.amount === b.amount && a.currency === b.currency;
}
function samePackQuotes(a, b) {
    const ids = Object.keys(a);
    if (ids.length !== Object.keys(b).length)
        return false;
    return ids.every((id) => id in b &&
        sameQuote(a[id], b[id]) &&
        a[id].perSession === b[id].perSession &&
        a[id].listAmount === b[id].listAmount);
}
function samePlanQuotes(a, b) {
    return (sameQuote(a.singleVisit, b.singleVisit) &&
        a.queueCurrency === b.queueCurrency &&
        samePackQuotes(a.packs, b.packs));
}
export const createScheduleSlice = (set, get) => {
    const detected = resolveBrowserTimezone();
    const applyTimezone = (tz) => set({
        selectedTimezone: tz,
        pendingTimezone: null,
        selectedSlot: null,
    });
    return {
        selectedDate: new Date(),
        selectedSlot: null,
        selectedTimezone: detected,
        detectedTimezone: detected,
        pendingTimezone: null,
        selectedPack: null,
        showAllPacks: false,
        availablePacks: [],
        planQuotes: NO_PLAN_QUOTES,
        selectedDuration: null,
        setSelectedDate: (date) => set({ selectedDate: date, selectedSlot: null }),
        setSelectedSlot: (slot) => {
            if (get().selectedSlot === slot)
                return;
            set({ selectedSlot: slot });
        },
        applyDetectedTimezone: (tz) => set({
            detectedTimezone: tz,
            selectedTimezone: tz,
            pendingTimezone: null,
        }),
        requestTimezoneChange: (tz) => {
            const { selectedTimezone, detectedTimezone } = get();
            if (tz === selectedTimezone)
                return;
            if (timezoneChangeNeedsConfirmation(tz, selectedTimezone, detectedTimezone)) {
                set({ pendingTimezone: tz });
                return;
            }
            applyTimezone(tz);
        },
        confirmTimezoneChange: () => {
            const { pendingTimezone } = get();
            if (!pendingTimezone)
                return;
            applyTimezone(pendingTimezone);
        },
        cancelTimezoneChange: () => set({ pendingTimezone: null }),
        setSelectedPack: (pack) => set(pack
            ? { selectedPack: pack, selectedActiveSessionPack: null }
            : { selectedPack: null }),
        setShowAllPacks: (v) => set({ showAllPacks: v }),
        setAvailablePacks: (packs) => set({ availablePacks: packs }),
        setPlanQuotes: (quotes) => {
            if (samePlanQuotes(get().planQuotes, quotes))
                return;
            set({ planQuotes: quotes });
        },
        setSelectedDuration: (mins) => {
            if (get().selectedDuration === mins)
                return;
            set({ selectedDuration: mins });
        },
    };
};
